import { _ } from "../../../core/polyglot/polyglot.js";
import { history, redo, undo } from "prosemirror-history";
import { keymap } from "prosemirror-keymap";
import AbstractAction from "./AbstractAction.js";

/**
 * Action taking care of the history management, and adding support for Undo and Redo.
 */
export default class HistoryAction extends AbstractAction {
	getPlugins() {
		return [
			history(),
			keymap({
				"Mod-z": undo,
				"Mod-y": redo,
			}),
		];
	}

	getMenuItems() {
		return [this._makeUndoItem(), this._makeRedoItem()];
	}

	_makeUndoItem() {
		return this._makeMenuItem({
			order: 1000,
			title: _("Undo last change"),
			run: undo,
			enable: (state) => undo(state),
			icon: this._makeIcon({ cssClass: "fa fa-rotate-left" }),
		});
	}

	_makeRedoItem() {
		return this._makeMenuItem({
			order: 1010,
			title: _("Redo last undone change"),
			run: redo,
			enable: (state) => redo(state),
			icon: this._makeIcon({ cssClass: "fa fa-rotate-right" }),
		});
	}
}
